export default __webpack_public_path__ + "static/media/SEARPENT_animated_150px.9623e2db.gif";